export default __webpack_public_path__ + "static/media/Simuladores.34cec7af.mp3";